/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntegrationFieldExistent
 */
export interface IntegrationFieldExistent {
    /**
     * 
     * @type {string}
     * @memberof IntegrationFieldExistent
     */
    fieldName: string;
    /**
     * The field name to map to.
     * @type {string}
     * @memberof IntegrationFieldExistent
     */
    mapToName?: string;
    /**
     * The display name to map to.
     * @type {string}
     * @memberof IntegrationFieldExistent
     */
    mapToDisplayName?: string;
}

/**
 * Check if a given object implements the IntegrationFieldExistent interface.
 */
export function instanceOfIntegrationFieldExistent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fieldName" in value;

    return isInstance;
}

export function IntegrationFieldExistentFromJSON(json: any): IntegrationFieldExistent {
    return IntegrationFieldExistentFromJSONTyped(json, false);
}

export function IntegrationFieldExistentFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationFieldExistent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fieldName': json['fieldName'],
        'mapToName': !exists(json, 'mapToName') ? undefined : json['mapToName'],
        'mapToDisplayName': !exists(json, 'mapToDisplayName') ? undefined : json['mapToDisplayName'],
    };
}

export function IntegrationFieldExistentToJSON(value?: IntegrationFieldExistent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fieldName': value.fieldName,
        'mapToName': value.mapToName,
        'mapToDisplayName': value.mapToDisplayName,
    };
}

